import { Component, OnInit } from '@angular/core';

import { NavController, AlertController, LoadingController, Loading} from 'ionic-angular';
import { AuthService } from '../../providers/auth-service'
import { SignupPage } from '../signup/signup'
import { TabsPage } from '../tabs/tabs'

@Component({
  selector: 'loging',
  templateUrl: 'login.html'
})
export class LoginPage {
  loading: Loading
  loginCredentials = {username: '', password: ''}

  constructor(
    private nav: NavController,
    private auth: AuthService,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController
    ) {}

    ngOnInit() {

    }

    public createAccount(){
      this.nav.push(SignupPage)
    }

    public login(){
      this.showLoading()
      this.auth.login(this.loginCredentials).subscribe(allowed => {
        if (allowed){
          setTimeout(() => {
            this.loading.dismiss();
            this.nav.setRoot(TabsPage)
          });
        } else {
          this.showError("Access Denied")
        }
      },
      error => {
        this.showError(error)
      });
    }


    showLoading(){
      this.loading = this.loadingCtrl.create({
        content: 'Please wait...'
      });

      this.loading.present();
    }

    showError(text){
      setTimeout( () => {
        this.loading.dismiss();
      });
      let alert = this.alertCtrl.create({
        title: 'Failed',
        subTitle: text,
        buttons: ['OK']
      });

      alert.present(prompt)
    }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts